import React, { useState, useEffect } from "react";
import api from "../../api";
import Select from "react-select";
import { FaDownload, FaSearch } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../StudentIdCardPage.css";

const AdmitCardPage = () => {
  const [form, setForm] = useState({ class_id: null, section_id: null });
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [students, setStudents] = useState([]);
  const [loadingStudents, setLoadingStudents] = useState(false);
  const [exams, setExams] = useState([]);
  const [exam_id, setExamId] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  const showToast = (type, msg) =>
    toast[type](msg, { position: "top-right", autoClose: 2000 });


const fetchExams = async () => {
  try {
    const school_id = localStorage.getItem("school_id");

    const res = await fetch(
      `https://dgps.co.in/api/admitcard/get-exams?school_id=${school_id}`
    );

    const data = await res.json();

    if (data.success) {
      setExams(data.data || []);
    } else {
      setExams([]);
    }

  } catch (err) {
    console.error(err);
    setExams([]);
  }
};

useEffect(() => {
  fetchClasses();
  fetchExams(); // 👈 add
}, []);
  /* ---------------- LOAD CLASSES ---------------- */
  const fetchClasses = async () => {
    try {
      const res = await api.get("/get-classes");
      if (res.data.success) setClasses(res.data.data);
    } catch (err) {
      console.error(err);
      showToast("error", "Unable to load classes");
    }
  };

  /* ---------------- LOAD SECTIONS ---------------- */
  const fetchSections = async (classId) => {
    try {
      const res = await api.get(`/get-sections/${classId}`);
      if (res.data.success) setSections(res.data.data);
      else setSections([]);
    } catch (err) {
      console.error(err);
      showToast("error", "Unable to load sections");
    }
  };

  /* ---------------- SEARCH STUDENTS ---------------- */
const fetchStudents = async () => {
  if (!form.class_id || !form.section_id) {
    showToast("warning", "Select class and section");
    return;
  }

  setLoadingStudents(true);

  try {
    const res = await fetch(
      `https://dgps.co.in/admitcard/get-students?class_id=${form.class_id}&section_id=${form.section_id}`
    );

    const data = await res.json();

    console.log("FINAL DATA:", data);

    if (data.success) {
      setStudents(data.data || []); // 🔥 FINAL LINE
    } else {
      setStudents([]);
    }

  } catch (err) {
    console.error(err);
    showToast("error", "Failed to load students");
  } finally {
    setLoadingStudents(false);
  }
};

// -----------------view-------------------------
const viewAdmit = async (stu) => {
  const id = stu.student_id || stu.id;

  const res = await fetch(
    `https://dgps.co.in/api/admitcard/view/${id}?exam_id=${exam_id}`
  );

  const data = await res.json();

  if (data.success) {
    setPreviewUrl(data.image_url); // 🔥 MAIN FIX
  }
};
  /* ---------------- DOWNLOAD ---------------- */
const downloadAdmit = (stu) => {
  const id = stu.student_id || stu.id;

  const link = document.createElement("a");
   link.href = `https://dgps.co.in/api/admitcard/view/${id}?exam_id=${exam_id}&dl=1`;
  link.download = "";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  return (
    <div className="id-container">
      <ToastContainer />

      <h2 className="title">Admit Card Generator</h2>

      {/* FILTER */}
      <div className="filter-card">
        <div className="row">
          
            <div className="col">
  <label>Select Exam</label>
  <Select
    options={exams.map(e => ({
      value: e.id,
      label: e.exam_name
    }))}
    onChange={(e) => setExamId(e ? e.value : null)}
    placeholder="Choose Exam"
  />
</div>
          {/* CLASS */}
          <div className="col">
            <label>Select Class</label>
            <Select
              options={classes.map(c => ({
                value: c.id,
                label: c.class_name
              }))}
              onChange={(e) => {
                if (!e) {
                  setForm({ class_id: null, section_id: null });
                  setSections([]);
                  setStudents([]);
                  return;
                }

                setForm({ class_id: e.value, section_id: null });
                fetchSections(e.value);
              }}
              placeholder="Choose Class"
            />
          </div>

          {/* SECTION */}
          <div className="col">
            <label>Select Section</label>
            <Select
              options={sections.map(s => ({
                value: s.id,
                label: s.section_name
              }))}
              isDisabled={!form.class_id}
              onChange={(e) =>
                setForm({ ...form, section_id: e ? e.value : null })
              }
              placeholder="Choose Section"
            />
          </div>

          {/* SEARCH */}
          <div className="col action">
            <button
              className="btn-primary"
              onClick={fetchStudents}
              disabled={loadingStudents}
            >
              <FaSearch />
              {loadingStudents ? " Searching..." : " Search Students"}
            </button>
          </div>

        </div>
      </div>

      {/* TABLE */}
      <div className="list-card">
        <h4 className="list-title">Student List</h4>

        {loadingStudents && (
          <div style={{ textAlign: "center", padding: "20px" }}>
            Loading students...
          </div>
        )}

        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Photo</th>
              <th>Name</th>
              <th>Roll</th>
              <th>Class</th>
              <th>Father</th>
              <th>Aadhaar</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {!loadingStudents && students.length === 0 && (
              <tr>
                <td colSpan="8" style={{ textAlign: "center" }}>
                  No students found
                </td>
              </tr>
            )}

            {students.map((stu, i) => (
              <tr key={stu.id}>
                <td>{i + 1}</td>

                <td>
                  <img
  src={stu.file}
  className="student-img"
  alt=""
  onError={(e) => (e.target.src = "/no-image.png")}
/>
                </td>

                <td>{stu.name}</td>
                <td>{stu.roll_no || stu.roll || stu.roll_number || "-"}</td>
                <td>{stu.class_name}-{stu.section_name}</td>
                <td>{stu.father_name}</td>
                <td>{stu.aadhaar_no}</td>

               <td>
  {/* VIEW BUTTON */}
  <button
    onClick={() => viewAdmit(stu)}
    style={{
      padding: "6px 12px",
      margin: "3px",
      border: "none",
      borderRadius: "6px",
      background: "#2196f3",
      color: "#fff",
      cursor: "pointer",
      transition: "0.3s"
    }}
    onMouseOver={(e) => (e.target.style.background = "#0b7dda")}
    onMouseOut={(e) => (e.target.style.background = "#2196f3")}
  >
    View
  </button>

  {/* DOWNLOAD BUTTON */}
  <button
    onClick={() => downloadAdmit(stu)}
    style={{
      padding: "6px 12px",
      margin: "3px",
      border: "none",
      borderRadius: "6px",
      background: "#4caf50",
      color: "#fff",
      cursor: "pointer",
      transition: "0.3s"
    }}
    onMouseOver={(e) => (e.target.style.background = "#388e3c")}
    onMouseOut={(e) => (e.target.style.background = "#4caf50")}
  >
    Download
  </button>
</td>
{previewUrl && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(102, 87, 87, 0.12)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999
    }}
  >
    <div
      style={{
        background: "#fff",
        width: "80%",
        maxWidth: "600px",
        borderRadius: "10px",
        padding: "15px",
        position: "relative"
      }}
    >
      {/* CLOSE BUTTON */}
      <span
        onClick={() => setPreviewUrl(null)}
        style={{
          position: "absolute",
          right: "15px",
          top: "10px",
          fontSize: "22px",
          cursor: "pointer"
        }}
      >
        ×
      </span>

      {/* PREVIEW */}
 <img
  src={previewUrl}
  alt="Admit Preview"
  style={{
    width: "100%",
    maxHeight: "500px",
    objectFit: "contain"
  }}
/>
    </div>
  </div>
)}

              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdmitCardPage;